import React, { useEffect, useState } from "react";
import { TbListDetails } from "react-icons/tb";
import {
  MdOutlineLocationOn,
  MdOutlineCastForEducation,
  MdGroups,
} from "react-icons/md";
import { LiaStarOfLifeSolid } from "react-icons/lia";
import { SiRelianceindustrieslimited } from "react-icons/si";
import { FaLayerGroup } from "react-icons/fa";
import { getPreference, addPreference } from "../../store/slices/preference";
import { getSubCaste } from "../../store/slices/profile";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";

const toSelectArray = (val) => (Array.isArray(val) ? val : val ? [val] : []);

const initPref = {
  minAge: "",
  maxAge: "",
  minHeight: "",
  maxHeight: "",
  maritalStatus: "",
  subCaste: "",
  motherTongue: "",
  country: "",
  state: "",
  district: "",
  willingtoRelocate: "",
  education: "",
  occupation: "",
  workingWith: "",
  incomeMin: "",
  incomeMax: "",
  familyType: "",
  // religion: "",
  // caste: "",
};

const formatIndianNumber = (value) => {
  if (!value) return "";

  const lastThree = value.substring(value.length - 3);
  const otherNumbers = value.substring(0, value.length - 3);

  if (otherNumbers !== "") {
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
  }
  return lastThree;
};

const convertCmToHeight = (cm) => {
  if (!cm) return "";

  const totalInches = Math.round(cm / 2.54);
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;

  return `${feet}'${inches}"`;
};

// Map GET <-- >  formData
const mapPreference = (data = {}) => ({
  minAge: data.ageMin ?? "",
  maxAge: data.ageMax ?? "",
  minHeight: data.heightMin ? convertCmToHeight(data.heightMin) : "",
  maxHeight: data.heightMax ? convertCmToHeight(data.heightMax) : "",
  maritalStatus: toSelectArray(data.maritalStatus)[0] ?? "",
  subCaste: toSelectArray(data.subCaste)[0] ?? "",
  motherTongue: data.motherTongue ?? "",
  country: toSelectArray(data.preferredCountry)[0] ?? "",
  state: toSelectArray(data.preferredState).join(", ") ?? "",
  district: toSelectArray(data.preferredDistrict).join(", ") ?? "",
  willingtoRelocate:
    data.willingtoRelocate === true
      ? "Yes"
      : data.willingtoRelocate === false
        ? "No"
        : "",
  education: toSelectArray(data.qualification)[0] ?? "",
  occupation: toSelectArray(data.occupation)[0] ?? "",
  workingWith: toSelectArray(data.workingWith)[0] ?? "",
  incomeMin: data.incomeMin ? formatIndianNumber(String(data.incomeMin)) : "",
  incomeMax: data.incomeMax ? formatIndianNumber(String(data.incomeMax)) : "",
  familyType: data.familyType ?? "",
  // religion: toSelectArray(data.religion)[0] ?? "",
  // caste: toSelectArray(data.caste)[0] ?? "",
});

const convertHeightToCm = (height) => {
  if (!height) return null;

  const parts = height.replace('"', "").split("'");
  const feet = parseInt(parts[0], 10);
  const inches = parseInt(parts[1] || 0, 10);

  return Math.round(feet * 30.48 + inches * 2.54);
};

//payload - >
const mapToPayload = (formData) => ({
  ageMin: Number(formData.minAge),
  ageMax: Number(formData.maxAge),
  heightMin: convertHeightToCm(formData.minHeight),
  heightMax: convertHeightToCm(formData.maxHeight),
  maritalStatus: formData.maritalStatus ? [formData.maritalStatus] : [],
  subCaste: formData.subCaste ? [formData.subCaste] : [],
  motherTongue: formData.motherTongue,
  preferredCountry: formData.country ? [formData.country] : [],
  preferredState: formData.state
    ? formData.state
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
    : [],
  preferredDistrict: formData.district
    ? formData.district
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
    : [],
  willingtoRelocate: formData.willingtoRelocate === "Yes",
  qualification: formData.education ? [formData.education] : [],
  occupation: formData.occupation ? [formData.occupation] : [],
  workingWith: formData.workingWith ? [formData.workingWith] : [],
  incomeMin: formData.incomeMin
    ? Number(formData.incomeMin.replace(/,/g, ""))
    : 0,
  incomeMax: formData.incomeMax
    ? Number(formData.incomeMax.replace(/,/g, ""))
    : 0,
  familyType: formData.familyType,
  // religion: formData.religion ? [formData.religion] : [],
  // caste: formData.caste ? [formData.caste] : [],
});

// section
const preferencefields = [
  {
    title: "Basic Preferences",
    fields: [
      {
        key: "minAge",
        label: "Age From",
        type: "select",
        options: Array.from({ length: 30 }, (_, i) => String(21 + i)),
      },
      {
        key: "maxAge",
        label: "Age To",
        type: "select",
        options: Array.from({ length: 30 }, (_, i) => String(21 + i)),
      },
      {
        key: "minHeight",
        label: "Height From",
        type: "select",
        options: [
          "4'6\"",
          "4'7\"",
          "4'8\"",
          "4'9\"",
          "4'10\"",
          "4'11\"",
          "5'0\"",
          "5'1\"",
          "5'2\"",
          "5'3\"",
          "5'4\"",
          "5'5\"",
          "5'6\"",
          "5'7\"",
          "5'8\"",
          "5'9\"",
          "5'10\"",
          "5'11\"",
          "6'0\"",
          "6'1\"",
          "6'2\"",
          "6'3\"",
          "6'4\"",
          "6'5\"",
          "6'6\"",
          "6'7\"",
          "6'8\"",
          "6'9\"",
          "6'10\"",
          "6'11\"",
          "7'",
        ],
      },
      {
        key: "maxHeight",
        label: "Height To",
        type: "select",
        options: [
          "4'6\"",
          "4'7\"",
          "4'8\"",
          "4'9\"",
          "4'10\"",
          "4'11\"",
          "5'0\"",
          "5'1\"",
          "5'2\"",
          "5'3\"",
          "5'4\"",
          "5'5\"",
          "5'6\"",
          "5'7\"",
          "5'8\"",
          "5'9\"",
          "5'10\"",
          "5'11\"",
          "6'0\"",
          "6'1\"",
          "6'2\"",
          "6'3\"",
          "6'4\"",
          "6'5\"",
          "6'6\"",
          "6'7\"",
          "6'8\"",
          "6'9\"",
          "6'10\"",
          "6'11\"",
          "7'",
        ],
      },
      {
        key: "maritalStatus",
        label: "Marital Status",
        type: "select",
        options: ["Unmarried", "Single", "Divorced", "Widowed"],
      },
      { key: "subCaste", label: "Sub Caste", type: "text" },
      {
        key: "motherTongue",
        label: "Mother Tongue",
        type: "select",
        options: ["Kannada", "Marathi", "Hindi", "Tamil", "Telugu"],
      },
      // { key: "religion", label: "Religion", type: "select", options: ["Hindu", "Muslim", "Christian", "Sikh", "Jain", "Buddhist"] },
      // { key: "caste", label: "Caste", type: "text" },
    ],
  },
  {
    title: "Location Preferences",
    fields: [
      { key: "country", label: "Country", type: "text" },
      { key: "state", label: "State (comma separated)", type: "text" },
      {
        key: "district",
        label: "District / City (comma separated)",
        type: "text",
      },
      {
        key: "willingtoRelocate",
        label: "Willing to Relocate",
        type: "select",
        options: ["Yes", "No"],
      },
    ],
  },
  {
    title: "Education & Career",
    fields: [
      {
        key: "education",
        label: "Qualification",
        type: "select",
        options: [
          "Aeronautical Engineering",
          "B.Arch",
          "BCA",
          "B.E/B.Tech",
          "B.Sc Eng.",
          "B.Plan",
          "Other Engineering",
          "B.A",
          "B.Com",
          "B.Sc",
          "B.S.W",
          "B.Phil",
          "BFA",
          "B.Ed",
          "Other ASC",
          "M.A",
          "M.Sc",
          "MBA",
          "MCA",
          "M.E/M.Tech",
          "M.Sc Eng.",
          "M.Arch",
          "PGDCA",
          "Other Master",
          "CA",
          "CS",
          "CFA",
          "ICWA",
          "PHD",
          "BAMS",
          "BDS",
          "BBA",
          "BHM",
          "MBBS",
          "B.Pharm",
          "M.Pharm",
          "Diploma",
          "PUC",
          "High School",
        ],
      },
      { key: "occupation", label: "Designation", type: "text" },
      {
        key: "workingWith",
        label: "Working With",
        type: "select",
        options: [
          "Private",
          "State Government",
          "Central Government",
          "PSU",
          "Self Employed",
          "Business",
          "Not Working",
          "Defence",
        ],
      },
      { key: "incomeMin", label: "Income Min (₹)", type: "text" },
      { key: "incomeMax", label: "Income Max (₹)", type: "text" },
    ],
  },
  {
    title: "Family Preferences",
    fields: [
      {
        key: "familyType",
        label: "Family Type",
        type: "select",
        options: ["Nuclear", "Joint", "Extended"],
      },
    ],
  },
];

// ----------> icon helper< ----------
const getIcon = (title) => {
  switch (title) {
    case "Basic Preferences":
      return <TbListDetails size={20} />;
    case "Location Preferences":
      return <MdOutlineLocationOn size={25} />;
    case "Education & Career":
      return <MdOutlineCastForEducation size={20} />;
    case "Lifestyle Preferences":
      return <LiaStarOfLifeSolid size={20} />;
    case "Star":
      return <SiRelianceindustrieslimited size={20} />;
    case "Family Preferences":
      return <MdGroups size={20} />;
    case "Additional Preferences":
      return <FaLayerGroup size={20} />;
    default:
      return "✨";
  }
};

// ---------- main component ----------
export default function PartnerPreference() {
  const dispatch = useDispatch();
  const { preferencelist = {}, loading } = useSelector(
    (state) => state.preference,
  );

  const [formData, setFormData] = useState(initPref);
  const [editSection, setEditSection] = useState(null);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const { subcaste = [] } = useSelector((state) => state.profile);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const keyword = searchText.trim();

    if (keyword.length < 2) return;

    const timer = setTimeout(() => {
      dispatch(getSubCaste({ search: keyword }));
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText, dispatch]);

  useEffect(() => {
    const fetch = async () => {
      try {
        await dispatch(getPreference()).unwrap();
      } catch (err) {
        toast.error(err || err?.message || "Failed to load preferences.");
      }
    };
    fetch();
  }, [dispatch]);

  useEffect(() => {
    if (preferencelist && Object.keys(preferencelist).length > 0) {
      setFormData(mapPreference(preferencelist));
    }
  }, [preferencelist]);

  const handleChange = (key, value, type, label) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    let error = "";

    if (!value || !value.toString().trim()) {
      error =
        type === "select"
          ? `Please select ${label.toLowerCase()}`
          : `Please enter ${label.toLowerCase()}`;
    }
    setErrors((prev) => ({ ...prev, [key]: error }));
  };

  const handleSave = async (sectionIndex) => {
    const section = preferencefields[sectionIndex];
    let hasError = false;
    const newErrors = {};

    if (formData.minAge && formData.maxAge) {
      if (Number(formData.maxAge) <= Number(formData.minAge)) {
        newErrors.maxAge = "Age To must be greater than Age From";
        hasError = true;
      }
    }

    if (formData.minHeight && formData.maxHeight) {
      const minH = convertHeightToCm(formData.minHeight);
      const maxH = convertHeightToCm(formData.maxHeight);

      if (maxH <= minH) {
        newErrors.maxHeight = "Height To must be greater than Height From";
        hasError = true;
      }
    }

    if (formData.incomeMin && formData.incomeMax) {
      const minIncome = Number(formData.incomeMin.replace(/,/g, ""));
      const maxIncome = Number(formData.incomeMax.replace(/,/g, ""));

      if (maxIncome <= minIncome) {
        newErrors.incomeMax = "Income Max must be greater than Income Min";
        hasError = true;
      }
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));

    if (hasError) {
      toast.error("Please fill all required fields.");
      return;
    }

    setSaving(true);

    try {
      const payload = mapToPayload(formData);

      const res = await dispatch(addPreference(payload)).unwrap();

      // Refresh latest data from server
      await dispatch(getPreference()).unwrap();

      toast.success(res?.message || "Preferences saved successfully!");

      setEditSection(null);
    } catch (err) {
      toast.error(err || err?.message || "Failed to save preferences.");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (preferencelist && Object.keys(preferencelist).length > 0) {
      setFormData(mapPreference(preferencelist));
    } else {
      setFormData(initPref);
    }
    setEditSection(null);
    setErrors({});
  };

  const formatIndianNumber = (value) => {
    if (!value) return "";

    const lastThree = value.substring(value.length - 3);
    const otherNumbers = value.substring(0, value.length - 3);

    if (otherNumbers !== "") {
      return (
        otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
      );
    }
    return lastThree;
  };

  return (
    <div className="ep-root">
      <div className="ep-page-header">
        <div className="ep-page-title">Partner Preferences</div>
        <div className="ep-page-sub">Manage your partner preference</div>
      </div>

      {preferencefields.map((section, index) => {
        const isEditing = editSection === index;

        return (
          <div className="ep-section" key={index}>
            <div className="ep-sec-header">
              <div className="ep-sec-left">
                <div className="ep-sec-icon">{getIcon(section.title)}</div>
                <div>
                  <div className="ep-sec-title">{section.title}</div>
                </div>
              </div>
              {!loading && (
                <button
                  className={`ep-edit-btn ${isEditing ? "editing" : ""}`}
                  onClick={() => setEditSection(isEditing ? null : index)}
                >
                  {isEditing ? "✕ Cancel" : "✎ Edit"}
                </button>
              )}
            </div>

            {loading ? (
              <div className="ep-view">
                <div className="ep-detail-grid">
                  {[1, 2, 3].map((item) => (
                    <div key={item} className="ep-detail-item">
                      <div
                        className="ep-skeleton-title"
                        style={{ width: "30%", marginBottom: "8px" }}
                      ></div>

                      <div className="ep-skeleton-line"></div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              !isEditing && (
                <div className="ep-view">
                  <div className="ep-detail-grid">
                    {section.fields.map((field) => (
                      <div key={field.key} className="ep-detail-item">
                        <div className="ep-detail-lbl">{field.label}</div>
                        <div
                          className={`ep-detail-val ${!formData[field.key] ? "empty" : ""}`}
                        >
                          {formData[field.key] || "Not specified"}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}

            {/* EDIT */}
            {isEditing && !loading && (
              <div className="ep-edit-form">
                <div className="ep-form-grid">
                  {section.fields.map((field) => (
                    <div className="ep-field" key={field.key}>
                      <label className="ep-lbl">{field.label}</label>
                      {field.type === "select" ? (
                        <>
                          <Select
                            className="ep-react-select"
                            classNamePrefix="ep-select"
                            isSearchable
                            placeholder={`Select ${field.label}`}
                            options={
                              (
                                field.key === "minHeight" ||
                                  field.key === "maxHeight" ||
                                  field.key === "minAge" ||
                                  field.key === "maxAge"
                                  ? field.options
                                  : [...field.options].sort((a, b) => a.localeCompare(b))
                              ).map((item) => ({
                                value: item,
                                label: item,
                              }))
                            }
                            value={
                              formData[field.key]
                                ? {
                                  value: formData[field.key],
                                  label: formData[field.key],
                                }
                                : null
                            }
                            onChange={(selected) =>
                              handleChange(
                                field.key,
                                selected ? selected.value : "",
                                "select",
                                field.label
                              )
                            }
                          />
                          {errors[field.key] && (
                            <small style={{ color: "red" }}>
                              {errors[field.key]}
                            </small>
                          )}
                        </>
                      ) : (
                        <>
                          {field.key === "subCaste" ? (
                            <>
                              <input
                                className="ep-input"
                                value={formData.subCaste || ""}
                                placeholder="Enter Sub Caste"
                                autoComplete="off"
                                onChange={(e) => {
                                  handleChange(
                                    field.key,
                                    e.target.value,
                                    "text",
                                    field.label
                                  );
                                  setSearchText(e.target.value);
                                }}
                              />

                              {searchText.trim().length >= 2 && subcaste.length > 0 && (
                                <div className="ep-autocomplete">
                                  {subcaste.map((item) => (
                                    <div
                                      key={item._id}
                                      className="ep-autocomplete-item"
                                      onClick={() => {
                                        handleChange(
                                          field.key,
                                          item.name,
                                          "text",
                                          field.label
                                        );
                                        setSearchText("");
                                      }}
                                    >
                                      {item.name}
                                    </div>
                                  ))}
                                </div>
                              )}

                              {errors[field.key] && (
                                <small style={{ color: "red" }}>
                                  {errors[field.key]}
                                </small>
                              )}
                            </>
                          ) : (
                            <>
                              <input
                                className="ep-input"
                                value={formData[field.key] || ""}
                                onChange={(e) => {
                                  const rawValue = e.target.value;
                                  const isIncomeField =
                                    field.label === "Income Min (₹)" ||
                                    field.label === "Income Max (₹)";

                                  if (isIncomeField) {
                                    let numericValue = rawValue.replace(/\D/g, "");

                                    if (!numericValue) {
                                      handleChange(field.key, "", "text", field.label);
                                      return;
                                    }

                                    handleChange(
                                      field.key,
                                      formatIndianNumber(numericValue),
                                      "text",
                                      field.label
                                    );
                                  } else {
                                    handleChange(
                                      field.key,
                                      rawValue.replace(/[^a-zA-Z\s.,-]/g, ""),
                                      "text",
                                      field.label
                                    );
                                  }
                                }}
                                placeholder={`Enter ${field.label}`}
                                maxLength={
                                  ["Income Min (₹)", "Income Max (₹)"].includes(field.label)
                                    ? 10
                                    : 50
                                }
                              />

                              {errors[field.key] && (
                                <small style={{ color: "red" }}>
                                  {errors[field.key]}
                                </small>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div className="ep-form-actions">
                  <button
                    className="ep-btn-cancel"
                    onClick={handleCancel}
                    disabled={saving}
                  >
                    Cancel
                  </button>
                  <button
                    className="ep-btn-save"
                    onClick={() => handleSave(index)}
                    disabled={saving}
                  >
                    {saving ? "Saving…" : "✓ Save"}
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
